import type { VariantProps } from 'class-variance-authority';

import * as React from 'react';
import { cva } from 'class-variance-authority';

import { cn } from '@shared/utils/cn';

// Hauteurs du TextField outlined Minimal (padding vertical + line-height 24px) :
// small 40 / medium 56 / large 64 (18px) / xlarge 72 (20px) / xxlarge 80 (24px, champ de scan)
const inputVariants = cva(
  'flex w-full min-w-0 rounded-lg border border-input bg-transparent shadow-none transition-[color,box-shadow] outline-none placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/20 aria-invalid:border-destructive aria-invalid:ring-destructive/20',
  {
    variants: {
      size: {
        sm: 'h-10 px-3.5 text-sm',
        default: 'h-14 px-3.5 text-base',
        lg: 'h-16 px-3.5 text-lg',
        xl: 'h-[72px] px-3.5 text-xl',
        xxl: 'h-20 px-3.5 text-2xl',
      },
    },
    defaultVariants: { size: 'default' },
  }
);

type InputProps = Omit<React.ComponentProps<'input'>, 'size'> & VariantProps<typeof inputVariants>;

const Input = ({ className, type, size, ...props }: InputProps) => (
  <input className={cn(inputVariants({ size }), className)} data-slot="input" type={type} {...props} />
);

export { Input, inputVariants };
